import type { StpInstance } from '@ipfabric/utils';
import type { StpInstanceData } from '../useStpInstances';

export const orderStpInstances = (
  instances: StpInstanceData[],
  appliedInstances: StpInstance[],
): StpInstanceData[] => {
  const firstInstances: StpInstanceData[] = [];
  const secondInstances: StpInstanceData[] = [];

  for (const instance of instances) {
    const foundAppliedInstance = appliedInstances.find(
      (appliedInstance) =>
        appliedInstance.rootId === instance.rootId &&
        appliedInstance.vlanId === instance.vlanId,
    );

    if (foundAppliedInstance) {
      firstInstances.push(instance);
    } else {
      secondInstances.push(instance);
    }
  }

  return [...firstInstances, ...secondInstances];
};
